<template>
  <article class="contact-search-card contact-search-card--clickable">
    <img
      v-if="image"
      :src="image"
      :alt="'Picture of location ' + name"
      class="contact-search-card__image"
    >

    <div class="contact-search-card__body">
      <span
        v-if="parentLocation"
        class="contact-search-card__parent-title"
      >
        {{ parentLocation.name }}
      </span>

      <h3 class="contact-search-card__title flex-grow-1">{{ name }}</h3>

      <a
        :href="url"
        class="contact-search-card__cta-link stretched-link"
      >
        Contacts &amp; information <i class="fal fa-long-arrow-right"></i>
      </a>
    </div>
  </article>
</template>

<script>
export default {
  name: 'ContactSearchLocationCard',

  props: {
    name: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    image: {
      type: [String, null],
      default: null,
    },
    parentLocation: {
      type: [Object, null],
      default: null,
    },
  }
}
</script>
